import React, { useState, useEffect } from 'react';
import { Calendar } from 'lucide-react';
import { Button } from './ui/button';
import { clinicInfo } from '../mockData';

export const FloatingBookButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleBookNow = () => {
    window.open(clinicInfo.bookingUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div
      className={`fixed bottom-6 right-6 z-40 transition-all duration-500 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
      }`}
    >
      <Button
        onClick={handleBookNow}
        className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-6 text-base font-semibold rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-110 group ring-4 ring-white/50"
      >
        <Calendar className="w-5 h-5 mr-2 group-hover:rotate-12 transition-transform" />
        Book Now
      </Button>
    </div>
  );
};
